<a *ngIf="imageUrl" data-track-group="Logo" data-track class="logo-link" [title]="courtSystemName" [routerLink]="['/']">
  <img class="logo" src="{{ imageUrl }}" alt="Logo for {{ courtSystemName }}" />
</a>
